import React, { useEffect, useRef, useState } from 'react';
import { LanguageId } from '~domain/model/core/supported-languages';
import { BaseNavbar, BaseNavbarProps, LanguageToggleButton } from '~frontend-common/components/base-navbar';
import { Box } from '~ui-kit/components/box/box';
import { ReferAFriendButton } from '~web-portal/components/refer-a-friend/refer-a-friend';
import { userService } from '~web-portal/services';
import { useAuthStore } from '~web-portal/stores';
import { Images } from '~web-portal/theme/images';
import { Paths } from '~web-portal/variables/paths';
import { NavbarHelpMenu } from './navbar-help-menu';
import { NavbarUserMenu } from './navbar-user-menu';

interface NavbarProps {
  logoLink?: BaseNavbarProps['logoLink'];
  isLoggedIn?: boolean;
}

export function Navbar({ logoLink = { path: Paths.policies }, isLoggedIn }: NavbarProps) {
  const authStore = useAuthStore();

  const changeLanguageTimeoutRef = useRef(null);
  const [isChangeLanguageDisabled, setChangeLanguageDisabled] = useState(false);

  useEffect(() => {
    return () => {
      if (changeLanguageTimeoutRef.current) {
        clearTimeout(changeLanguageTimeoutRef.current);
      }
    };
  }, []);

  const onBeforeLanguageChange = async (language: LanguageId) => {
    if (changeLanguageTimeoutRef.current) {
      return;
    }

    setChangeLanguageDisabled(true);
    changeLanguageTimeoutRef.current = setTimeout(() => {
      changeLanguageTimeoutRef.current = undefined;
      setChangeLanguageDisabled(false);
    }, 5000);

    if (authStore.isLoggedIn()) {
      await userService.updateLanguage(language);
    }
  };

  return (
    <BaseNavbar logoLink={logoLink} imageSrc={Images} additionalContent={() => null}>
      <Box gridGap="8px" display="flex" alignItems="center">
        <LanguageToggleButton disabled={isChangeLanguageDisabled} onBeforeLanguageChange={onBeforeLanguageChange} />

        {isLoggedIn && <ReferAFriendButton />}

        <NavbarHelpMenu />

        {isLoggedIn && <NavbarUserMenu />}
      </Box>
    </BaseNavbar>
  );
}
